/**
 * @module avast.web.balloon
 * Toggle balloons 
 * @author <gabriel@avast.com>`
 * @version 0.0.1
 */

(function(){
	avm.define('avast.web.balloon', function(){
		var $ = avm.require('jquery');
		
		$('.js-balloon-trigger').on('mouseover', function(evt){
			var target = evt.currentTarget;

			$(target).next('.js-balloon').removeClass('hidden')
		});

		$('.js-balloon-trigger').on('mouseout', function(evt){
			var target = evt.currentTarget;

			$(target).next('.js-balloon').addClass('hidden')
		});
	});
	// Init ballons
	avm.require('avast.web.balloon')();
})();

 